import React, { createContext, useContext, useState } from 'react';

const ProfileContext = createContext({
    viewedUserId: null,
    viewedUserName: null,
    isOwnProfile: true,
    setViewedUser: (userId, userName) => {},
    clearViewedUser: () => {},
});

export const ProfileProvider = ({ children }) => {
    const [viewedUserId, setViewedUserId] = useState(null);
    const [viewedUserName, setViewedUserName] = useState(null);
    const [isOwnProfile, setIsOwnProfile] = useState(true);

    const setViewedUser = (userId, userName) => {
        setViewedUserId(userId);
        setViewedUserName(userName);
        setIsOwnProfile(false);
    };

    const clearViewedUser = () => {
        setViewedUserId(null);
        setViewedUserName(null);
        setIsOwnProfile(true);
    };

    return (
        <ProfileContext.Provider 
            value={{ 
                viewedUserId, 
                viewedUserName, 
                isOwnProfile, 
                setViewedUser, 
                clearViewedUser 
            }}
        >
            {children}
        </ProfileContext.Provider>
    );
};

export const useProfile = () => useContext(ProfileContext);
